import { Label } from '@r1-frontend/ui-react/components/label';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';

import * as ST from './styled';

interface IProps {
    labelText: string,
}

const PromoDurationBlock = ({ labelText }: IProps): JSX.Element => {
    return (
        <ST.Wrapper>
            <ST.TextBlock>
                <Label type={'LabelsText_2'}>{labelText}</Label>
                <ST.ReminderWrapper>
                    <Paragraph5>Пришлём смс за&nbsp;3&nbsp;дня до&nbsp;оплаты</Paragraph5>
                </ST.ReminderWrapper>
            </ST.TextBlock>
            <ST.ProgressBarWrapper>
                <ST.ProgressBar/>
            </ST.ProgressBarWrapper>
        </ST.Wrapper>
    );
};

export default PromoDurationBlock;
